import React, { useEffect, useState } from "react";
import { CartItem } from "./CartItem";
import { Close, LocalOffer } from "@mui/icons-material";
import { teal } from "@mui/material/colors";
import {
  Button,
  IconButton,
  TextField,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { PricingCart } from "./PricingCart";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../State/Store";
import { findUserCartHandler, resetCart } from "../../../State/customer/CartSlice";

export const Cart = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const dispatch = useAppDispatch();
  const { cart } = useAppSelector((store) => store.cart|| { cartItems: [] });
  const {order} = useAppSelector((store)=>store)
  const [message, setMessage] = useState<null | string>(null);
  const isLarge = useMediaQuery(theme.breakpoints.up("lg"));


  // Initial Render: It will execute dispatch(findUserCartHandler()) immediately when the component mounts.
  // Subsequent Renders: It will only re-run if the value of cart.isDeleted changes.

useEffect(() => {  
  dispatch(findUserCartHandler())
},[dispatch])
useEffect(() => {
  if (!cart || !cart.cartItems) return;

  if (cart.cartItems.length === 0) {
    setMessage("Your basket awaits treasures. Shop more to get vouchers.");
  } else {
    setMessage(null);
  }
}, [cart?.cartItems?.length]);
useEffect(() => {
  if (!order?.isSuccess) return;  // chỉ khi true mới chạy
  dispatch(resetCart());
  dispatch(resetOrderState())
}, [order?.isSuccess, dispatch]);

return (
    <div className="pt-10 px-5 sm:px-10 md:px-40 lg:px-60 min-h-screen">
      {/* In a grid layout with 3 columns, the boxes can be styled to span different numbers of columns based on the col-span-x value. This helps control how much space each element takes up in the grid. Let me know if this helps or if you need further clarification! ​ */}
      {message ? (
        <h1 className="text-primary text-center font-semibold text-2xl">
          {message}
        </h1>
      ) : (
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-3">
          {/* left side */}
          <div className="cartItemSection lg:col-span-2 space-y-3">
          {cart?.cartItems?.length > 0 ? (
    cart.cartItems.map((item, index) => (
      <CartItem setMessage={setMessage} cartItem={item} key={index} />
    ))
  ) : (
    <p className="text-primary text-center font-semibold text-2xl">
      Your basket awaits treasures. Shop more to get vouchers.
    </p>
  )}
          </div>
          {/* right side */}
          {/* col-span-1: The blue box spans 1 column.
         col-span-2: The green box spans 2 columns, taking up more space. */}
          <div className="col-span-1 text-sm space-y-3">
            {/* Coupon section */}

            <div className="border rounded-md px-5 py-3 space-y-5">
              <div className="flex gap-3 text-sm items-center ">
                <div className="flex gap-3 text-sm items-center">
                  <LocalOffer sx={{ color: teal[600], fontSize: "17px" }} />
                </div>
                <span>Apply Coupon</span>
              </div>
              {/* input field for coupon  */}
              {true ? (
                <div className="flex justify-between lg:justify-around items-center">
                  <TextField
                    // onChange={handleChange}
                    id="outlined-basic"
                    placeholder="Coupon Code"
                    size="small"
                    variant="outlined"
                  />
                  <Button
                    variant="contained"
                    size={isLarge ? "large" : "small"}
                  >
                    Apply
                  </Button>
                </div>
              ) : (
                <div className="flex">
                  <div className="p-1 pl-5 pr-3 border rounded-md flex gap-2 items-center">
                    <span className="">Coupon Applied</span>
                    <IconButton size="small">
                      <Close className="text-red-600" />
                    </IconButton>
                  </div>
                </div>
              )}
            </div>

            {/* Invoice section */}

            <div className="border rounded-md ">
              <PricingCart />
              <div className="p-5">
                <Button
                  onClick={() => {
                    navigate("/checkout");
                  }}
                  fullWidth
                  variant="contained"
                  sx={{ py: "11px" }}
                >
                  Buy Now
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
function resetOrderState(): any {
  throw new Error("Function not implemented.");
}

